import { Field } from '#app/components/form/field.tsx'
import { SelectField } from '#app/components/form/select-field.tsx'
import { type ProductDataSourceValue } from '#app/routes/mocra+/_form+/components/products/schema.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { PRODUCT_DATA_SOURCE_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly value: ProductDataSourceValue
	readonly errors: readonly string[]
	readonly showOther: boolean
	readonly otherValue: string
	readonly otherErrors: readonly string[]
	readonly onValueChange: (value: ProductDataSourceValue) => void
	readonly onOtherChange: (value: string) => void
}

export function ProductSystemSection({
	resources,
	value,
	errors,
	showOther,
	otherValue,
	otherErrors,
	onValueChange,
	onOtherChange,
}: Props) {
	return (
		<Section
			title="System of record"
			description="Point us to the master product data source so we can note it in SOP references and audit responses."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<SelectField
				labelProps={{
					children: 'Where do you keep the authoritative product data?',
				}}
				selectProps={{
					name: 'productDataSource',
					value,
					onChange: (event) =>
						onValueChange(event.target.value as ProductDataSourceValue),
				}}
				descriptionProps={{
					children:
						'Choose the system that drives product master data for listings, safety substantiation, and recalls.',
				}}
				placeholder="Select a system"
				options={PRODUCT_DATA_SOURCE_OPTIONS}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
			{showOther ? (
				<Field
					labelProps={{
						children: 'Name the system or repository',
					}}
					inputProps={{
						name: 'productDataSourceOther',
						type: 'text',
						value: otherValue,
						onChange: (event) => onOtherChange(event.target.value),
					}}
					descriptionProps={{
						children:
							'Provide the vendor, database, or internal tool storing product records.',
					}}
					errors={otherErrors.length > 0 ? [...otherErrors] : undefined}
				/>
			) : null}
		</Section>
	)
}
